// extracted by mini-css-extract-plugin
export default {"container":"Notes_container__6opej"};